import _ from 'lodash';

export function mergeStates<T, S>(
    this: T,
    state: S,
    ...newPartialState: (Partial<S> | object)[]
): S {
    return _.merge.apply(this, [{}, state, ...newPartialState]);
}

export function cloneStates<T, S>(this: T, state: S): S {
    return _.merge.apply(this, [{}, state]);
}
